var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 16.5C6.41751 16.5 4.87079 16.0308 3.5552 15.1517C2.2396 14.2727 1.21422 13.0233 0.608723 11.5615C0.00322211 10.0997 -0.155205 8.49112 0.153477 6.93927C0.462159 5.38743 1.22408 3.96197 2.34291 2.84315C3.46173 1.72433 4.88719 0.962403 6.43904 0.653721C7.99088 0.34504 9.59942 0.503466 11.0612 1.10897C12.523 1.71447 13.7725 2.73985 14.6515 4.05544C15.5306 5.37103 15.9998 6.91775 15.9998 8.49999C15.9974 10.621 15.1538 12.6544 13.654 14.1542C12.1542 15.654 10.1208 16.4976 7.99976 16.5ZM7.99976 18.5C5.83315 18.499 3.7262 17.79 1.99976 16.481V22C1.99975 22.4709 2.13277 22.9323 2.38349 23.331C2.63421 23.7296 2.99244 24.0494 3.41692 24.2533C3.8414 24.4573 4.31486 24.5373 4.78278 24.4839C5.25071 24.4306 5.69405 24.2462 6.06176 23.952L7.68776 22.652C7.77636 22.5812 7.88638 22.5427 7.99976 22.5427C8.11314 22.5427 8.22316 22.5812 8.31176 22.652L9.93776 23.952C10.3055 24.2462 10.7488 24.4306 11.2167 24.4839C11.6847 24.5373 12.1581 24.4573 12.5826 24.2533C13.0071 24.0494 13.3653 23.7296 13.616 23.331C13.8667 22.9323 13.9998 22.4709 13.9998 22V16.481C12.2732 17.7899 10.1663 18.4989 7.99976 18.5Z",
    fill: "#118AB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.73daf51e41d665299fc682bc3cb53878.svg";
export { ForwardRef as ReactComponent };